import React from "react";
import RichText from "components/rich-text";
import Button from "helpers/button";
import { getVerticalAlign } from "helpers/get-section-align";
import getBackgroundColor from "helpers/generate-background";

const components = {
  normal: ({ children }) => (
    <p className="text-base text-gray-700 font-montserrat font-medium">{children}</p>
  ),
};

const TwoColumns = ({ data }) => {
  const {
    insideContainer,
    verticalAlign: { verticalAlign },
    changeOrder,
    changeOrderMobile,
    title,
    description,
    buttons,
    image,
    imageBorder,
    settings: { backgroundColor }
  } = data;

  return (
    <div className="background-gray">
      <div
      className={`container ${insideContainer 
        ? "" 
        : `!max-w-[calc(100%-(100%-1280px)/2)] ${changeOrder ? "!ml-0 !pl-0" : "!mr-0 !pr-0"} sm:!mx-0 sm:!px-0`
      }`}
    >
      <div
        className={`flex justify-between sm:gap-10 gap-16 ${getVerticalAlign(
          verticalAlign
        )} ${changeOrder ? "flex-row-reverse" : "flex-row"} ${changeOrderMobile ? "sm:flex-col-reverse" : "sm:flex-col"}`}
      >
        <div
          className={`sm:w-full sm:text-center w-1/2 ${
            insideContainer ? "" : "!max-w-[500px] container !px-0 sm:!px-4"
          }`}
        >
          <h2 className="header mb-6">{title}</h2>
          <div className="paragraph-normal text-gray-700 font-montserrat text-base font-medium">
            <RichText value={description.data} components={components} />
          </div>

          {buttons && (
            <div className="flex items-center gap-4 mt-6 sm:justify-center sm:pb-10">
              {buttons.map((button, index) => (
                <Button button={button} key={index} className="!px-10" />
              ))}
            </div>
          )}
        </div>
        <div
          className={`rounded sm:w-full ${
            insideContainer ? "w-3/5" : "flex-1"
          } ${imageBorder ? "border-solid border-2 border-yellow-300" : ""}`}
        >
          <img src={image?.src} alt={image?.alt} className="w-full h-full" />
        </div>
      </div>
    </div>
    </div>
  );
};

export default TwoColumns;
